export const BRIDGE_PROTOCOL_VERSION = 1;
export function isInWebView() {
    return typeof window.ReactNativeWebView !== "undefined";
}
export function getNativeCapabilities() {
    try {
        const raw = window.__CC_NATIVE_CAPABILITIES__;
        if (!raw || typeof raw !== "object") {
            return {};
        }
        return raw;
    }
    catch {
        return {};
    }
}
export function supportsNativeLoginRedirect() {
    return Boolean(getNativeCapabilities().supportsNativeLoginRedirect);
}
export function supportsSessionBundle() {
    return Boolean(getNativeCapabilities().supportsSessionBundle);
}
export function hasNativeDialerBridge() {
    return Boolean(window.__CC_NATIVE_DIALER_BRIDGE__);
}
export function hasNativeClipboardBridge() {
    return Boolean(window.__CC_NATIVE_CLIPBOARD_BRIDGE__);
}
function getNativeSessionEpoch() {
    try {
        const raw = window.__CC_NATIVE_SESSION_CONTEXT__?.sessionEpoch;
        if (typeof raw !== "number" || !Number.isFinite(raw) || raw < 0) {
            return undefined;
        }
        return Math.floor(raw);
    }
    catch {
        return undefined;
    }
}
export function buildNativeBridgeMessage(type, data, options = {}) {
    const epoch = options.includeSessionEpoch === false ? undefined : getNativeSessionEpoch();
    return {
        v: BRIDGE_PROTOCOL_VERSION,
        type,
        data,
        ...(epoch == null ? {} : { epoch }),
    };
}
export function postToNative(type, data, options = {}) {
    try {
        if (!isInWebView()) {
            return false;
        }
        window.ReactNativeWebView.postMessage(JSON.stringify(buildNativeBridgeMessage(type, data, options)));
        return true;
    }
    catch {
        return false;
    }
}
